import request from '@/utils/request'

const table={
  // 业绩首页
  achievementIndex(data) {
    return request({
      url: '/clairvoyance/technician/achievement/index',
      method: 'post',
      data
    })
  },
  // 获取格言
  getMotto(data) {
    return request({
      url: '/clairvoyance/technician/default/get-motto',
      method: 'post',
      data
    })
  },
  // 业绩详情
  serviceDetail(data) {
    return request({
      url: '/clairvoyance/technician/achievement/service-detail',
      method: 'post',
      data
    })
  },
  // 推销详情
  sellDetail(data) {
    return request({
      url: '/clairvoyance/technician/achievement/sell-detail',
      method: 'post',
      data
    })
  },
  // 售卡详情
  sellCardDetail(data) {
    return request({
      url: '/clairvoyance/technician/achievement/sell-card-detail',
      method: 'post',
      data
    })
  },
  // 技师排行榜
  rankingList(data) {
    return request({
      url: '/clairvoyance/technician/ranking/list',
      method: 'post',
      data
    })
  },
  // 个人中心-首页
  centerIndex(data) {
    return request({
      url: '/clairvoyance/technician/center/index',
      method: 'post',
      data
    })
  },
  // 修改推送选项
  changePushOption(data) {
    return request({
      url: '/clairvoyance/technician/member/change-push-option',
      method: 'post',
      data
    })
  },
  // 可用门店列表
  getShopList(data) {
    return request({
      url: '/clairvoyance/technician/default/shop-list',
      method: 'post',
      data
    })
  },
  // 切换门店
  changeNodeId(data) {
    return request({
      url: '/clairvoyance/technician/default/change-node-id',
      method: 'post',
      data
    })
  },
  // 会员列表
  getmemberList(data) {
    return request({
      url: '/clairvoyance/technician/member/list',
      method: 'post',
      data
    })
  },
  // 编辑会员
  editMember(data) {
    return request({
      url: '/clairvoyance/technician/member/edit',
      method: 'post',
      data
    })
  },
  // 祝福模版-列表
  memberTemplateList(data) {
    return request({
      url: '/clairvoyance/technician/member/template-list',
      method: 'post',
      data
    })
  },
  // 祝福模版-上报
  memberTemplateReport(data) {
    return request({
      url: '/clairvoyance/technician/member/template-report',
      method: 'post',
      data
    })
  }
}
export default table
